module.exports = __webpack_public_path__ + "img/banner.0849f81.png";